import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FormButtons, Error, FormRow, DateFormWidget } from '../controls';

const PerformanceSchema = Yup.object({
  performer: Yup.object()
    .shape({
      performerName: Yup.string().min(1).required('Performer is required'),
    })
    .required('Performer is required'),
});

export function PerformanceForm({
  performance,
  handleSave,
  handleDateChange,
  performers,
  performerUpdated,
  handleRemove,
}) {
  const defaultDateObject = {
    startTime: performance.startTime || null,
    endTime: performance.endTime || null,
    startTimeMS: performance.startTimeMS || null,
    endTimeMS: performance.endTimeMS || null,
  };
  const dates = [defaultDateObject];
  const defaultValues = {
    performanceNotes: performance.performanceNotes || '',
    performer: performance.performer || {},
    performerId: performance.performer
      ? performance.performer.performerId || 0
      : 0,
    dates,
  };

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={handleSave}
      validationSchema={PerformanceSchema}
    >
      {({ errors, values, setFieldValue }) => (
        <Form>
          <FormRow label="Performer">
            <select
              className="h-10 w-full rounded-[20px] border border-[var(--festy-input-border)] px-4 outline-none"
              value={
                values.performer?.performerId
                  ? String(values.performer.performerId)
                  : ''
              }
              onChange={(e) => {
                const id = e.target.value;
                const performer = performers.find(
                  (p) => String(p.performerId) === id,
                );
                setFieldValue('performer', performer || {});
                setFieldValue('performerId', performer?.performerId ?? 0);
                if (performer) {
                  performerUpdated(performer);
                }
              }}
            >
              <option value="">Select a performer</option>
              {performers.map((performer) => (
                <option
                  key={performer.performerId}
                  value={String(performer.performerId)}
                >
                  {performer.performerName}
                </option>
              ))}
            </select>
            {errors.performer && (
              <Error>{errors.performer.performerName}</Error>
            )}
          </FormRow>
          <DateFormWidget
            label="Date & Times"
            dates={dates}
            handleDateChange={handleDateChange}
            required
          />
          <FormRow label="Notes">
            <Field
              component="textarea"
              name="performanceNotes"
              placeholder="Performance Notes..."
            />
          </FormRow>
          <FormButtons
            showDelete={performance.performanceId}
            label="Performance"
            onDelete={handleRemove}
          />
        </Form>
      )}
    </Formik>
  );
}
